import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, AppBar, Toolbar, IconButton, Typography, TextField, CircularProgress } from '@material-ui/core'
import { show, update, store, change, success as changeSuccess } from '../../../store/actions/roulette.action'
import { changeScreenB } from '../../../store/actions/navigation.action'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaSave } from 'react-icons/fa'
import MaskedInput from 'react-text-mask'

const TextMaskCustom = (props) => {
    const { inputRef, ...other } = props;
    let mask = [];

    if (props.name === 'qtd') {
        mask = [/[0-9]/, /\d/, /\d/]
    }

    return (
        <MaskedInput
            {...other}
            ref={ref => {
                inputRef(ref ? ref.inputElement : null)
            }}
            mask={mask}
            guide={false}
        />
    )
}

const RouletteEdit = (props) => {
    const dispatch = useDispatch()
    const { award, error } = useSelector(state => state.rouletteReducer)
    const campaign_id = (props.campaign_id) ? props.campaign_id : null
    const id = (props.uid) ? props.uid : null;
    const [qtd, setQtd] = React.useState(1)
    const [isLoading, setLoading] = React.useState(true)

    React.useEffect(() => {
        _index()
        return () => {
            dispatch(changeSuccess(false))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const _index = () => {
        if (id) {
            dispatch(show(id)).then(() => setLoading(false))
        } else {
            dispatch(change('clear'))
            setLoading(false)
        }
    }

    const _save = () => {
        if(id) {
            dispatch(update({
                'id' : id,
                'campaign_id' : campaign_id,
                'title' : award.title
            }))
        } else {
            dispatch(store({
                'qtd' : parseInt(qtd),
                'campaign_id' : campaign_id,
                'title' : award.title
            }))
        }
    }

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreenB({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">
                        {(id) ? 'Editar Prêmio' : 'Novo Prêmio'}
                    </Typography>

                    <Button onClick={() => _save()} color="inherit" className="ms-auto">
                        <FaSave className="me-2" /> Salvar
                    </Button>
                </Toolbar>
            </AppBar>

            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
            <>

                <div className="card card-body mt-3 bs-bg">
                    {!id &&
                        <div className="mb-3">
                            <label className="label-custom d-block bs-color-b">Quantidade</label>
                            <TextField
                                error={(error.qtd) && true}
                                name="qtd"
                                type="tel"
                                InputProps={{
                                    inputComponent: TextMaskCustom,
                                    value: qtd,
                                    placeholder: '1',
                                    onChange: e => {
                                        setQtd(e.target.value ? parseInt(e.target.value) : e.target.value)
                                        if (error.qtd && delete error.qtd);
                                    }
                                }}
                            />

                            {(error.qtd) &&
                                <strong className="text-danger">{error.qtd[0]}</strong>
                            }
                        </div>
                    }

                    <div className="mb-5">
                        <label className="label-custom bs-color-b">Prêmio</label>
                        <TextField
                            error={(error.title) && true}
                            value={award.title || ''}
                            placeholder="Ex: R$ 100"
                            onChange={text => {
                                dispatch(change({ title: text.target.value }))
                                if (error.title && delete error.title);
                            }}
                        />

                        {(error.title) &&
                            <strong className="text-danger">{error.title[0]}</strong>
                        }
                    </div>

                    <div className="mb-3">
                        <div className="alert alert-success mt-3" role="alert">
                            <strong>Roleta:</strong> Para a Roleta aparecer precisa cadastrar no minimo 9 prêmios 
                        </div>
                        <div className="alert alert-warning mt-3" role="alert">
                            Todos os prêmios ficam <strong>travados</strong>, você pode ir liberando a qualquer momento.
                        </div>
                    </div> 
                </div>
            </>
            }
            </div>
        </>
    )
}

export default RouletteEdit